import React from 'react'
import { Box, } from '@mui/material';


import AdminInfo from './AdminInfo';
import UserInfoSection from '../../ChatMessenger/bot-profile-chat/UserInfoSection';
import EditAboutInfo from '../../ChatMessenger/bot-profile-chat/EditAboutInfo';
import EditAboutLonging from '../../ChatMessenger/bot-profile-chat/EditAboutLonging';
import EditLuxeInfo from '../../ChatMessenger/bot-profile-chat/EditLuxeInfo';
import VerificationSection from '../../ChatMessenger/bot-profile-chat/VerificationSection';
import DevicesSection from './DevicesSection';


const UserRightSidebar = ({ userData,isDeletedAccount }) => {
  return (
    <Box sx={{ width: '100%', background: { xs: '#F9F6F3', sm: 'none' }, padding: { xs: '15px 15px 0 15px', sm: '0' } }}>
      <AdminInfo userData={userData} isDeletedAccount={isDeletedAccount}/>
      <UserInfoSection memberData={userData} isEditBtn={false} fieldsToShow={['Gender', 'Occupation',"Intent"]} />
      {userData?.aboutUsDescription && <EditAboutInfo memberData={userData} isEditBtn={false} />}
      {/* {userData?.preferences?.aboutPartnerDescription && <EditAboutLonging memberData={userData} isEditBtn={false} />} */}
      {/* {userData?.luxuryInterests && <EditLuxeInfo memberData={userData} isEditBtn={false} />} */}
      {
        (
          userData?.isInstagramVerified ||
          userData?.isLinkedinVerified ||
          userData?.isFacebookVerified ||
          userData?.isTwitterVerified ||
          userData?.isProfileVerified ||
          userData?.isIdVerified
        ) && <VerificationSection memberData={userData} showOnlyVerified />
      }
      <DevicesSection devices={userData?.devices} />
    </Box>
  )
}

export default UserRightSidebar
